import { API_endpoints } from "../config"; 

export const logout = async () => {
    try {
        const response = await fetch(API_endpoints.logout, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({}), 
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Beenden der Sitzung.");
        }

    } catch (error) {
        console.error("Fehler beim session checken:", error);
        throw error; 
    }
};